module.exports = {"410205001":"三里堡街道","410205002":"新门关街道","410205003":"繁塔街道","410205004":"官坊街道","410205005":"菜市街道","410205200":"南郊乡","410205201":"汪屯乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410205.json
// module id = 1531
// module chunks = 0